export enum LotPdfReport {
    DraftCreateSchedule = 1,
    HLFlyer,
    SimColourSchedule,
    PropertyInformation,
    ClientPropertyInformation,
    SiteEvaluation,
    LotSpecReport,
    CreateBookCoverPage1,
    CreateBookCoverPage2
}
